import { FilterList } from '@rdTypes/shared';
import { isArray } from 'lodash';
import { AutomationSetType } from 'src/types/apiContract';

export const SORT_HELPER = {
  asc: 'desc',
  desc: 'asc',
};

export const undefinedCompare = (value: any, defaultValue: any) => (value === undefined ? defaultValue : value);

export const clearEmptyValues = <T>(value?: T | T[] | null): T[] => {
  if (!value) return [];
  if (Array.isArray(value)) {
    return value.filter((item) => !!item);
  }
  return [value];
};

export const clearUnusedFilters = (filters: FilterList) =>
  Object.keys(filters || {}).reduce((acc: FilterList, item) => {
    if (isArray(filters[item]) && !filters[item].length) {
      return acc;
    }
    if (!['', undefined, null].includes(filters[item])) {
      acc[item] = filters[item];
    }
    return acc;
  }, {});

export const plural = (number = 0, suffix = '') => (number !== 1 ? suffix : '');

export function flattenObject<T extends Record<string, any>>(obj: T, prefix: string = ''): Record<string, any> {
  return Object.entries(obj).reduce((result, [key, value]) => {
    const newKey = prefix ? `${prefix}.${key}` : key;

    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      Object.assign(result, flattenObject(value, newKey));
    } else {
      result[newKey] = value;
    }

    return result;
  }, {} as Record<string, any>);
}

export function uuidv4(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export const getIsInReceiveSession = () => new URLSearchParams(window.location.search).get('sessionId');

export const isConnectionError = (error: any) => {
  if (error && 'data' in error && error.data != null) {
    const errorMessage = (error.data as { userMessage?: string }).userMessage;
    if (errorMessage) {
      return errorMessage.includes('Connection') && errorMessage.includes('does not exist');
    }
  }
  return false;
};

export const preparePieceFilters = (filters: FilterList): FilterList => {
  const preparedFilters = { ...filters };

  if (
    preparedFilters.receivedBy &&
    Array.isArray(preparedFilters.receivedBy) &&
    preparedFilters.receivedBy.length > 0
  ) {
    preparedFilters.ReceivedBy = preparedFilters.receivedBy.join(',');
    delete preparedFilters.receivedBy;
  }

  return preparedFilters;
};

const getExludeString = (count: number) => (count ? ' excluding ' + count : '');

export const getAutomationDisplayText = (type: AutomationSetType, count: number, groupName?: string | null) => {
  switch (type) {
    case AutomationSetType.AllRecipients:
      return `All${getExludeString(count)}`;

    case AutomationSetType.SpecificRecipients:
      return count;

    case AutomationSetType.UserGroups:
      return `${groupName || ''}${getExludeString(count)}`;
    default:
      return;
  }
};
